Array.prototype.keySort = function(key, desc) {
  this.sort(function(a, b) {
    var result = desc ? a[key] < b[key] : a[key] > b[key]
    return result ? 1 : -1
  })
  return this
}
